export type CoverTextType = 'alt' | 'dynamic' | 'info';

interface ICoverText {
  alt: string;
  dynamic: string;
  info?: string;
}

interface ICoverTexts {
  [key: string]: ICoverText;
}

const coverTexts: ICoverTexts = {
  gadget_cover: {
    alt: 'Gadgets aren’t covered as standard. Would you like to add Gadget Cover to protect your devices, like your mobile phone, laptop, tablet or camera?',
    dynamic: '**Excess:**\n\nA £50 excess applies to each claim, unless you’ve added the optional excess waiver.\n\n**How wear and tear (depreciation) works:**\n\nGadgets under 12 months old: we treat as new and don’t take anything away for wear and tear. Gadgets more than 12 months old: we take away an amount for wear and tear. We use a yearly percentage of 10% to do this. For example:\n\nIf your gadget cost £1,000 and you’ve had it for 3 years, we reduce its value by 10% for each year. That means we take £300 off for wear and tear, so we value your gadget at £700 before we take off your excess. We’d then take your excess amount away from this £700, unless you’ve bought an excess waiver.\n\nPlease note: We only cover items if you can give us proof of purchase.',
  },
  enhanced_trip_disruption: {
    alt: 'If you book a holiday in the UK or abroad, you can add this cover. It gives you extra protection against travel disruption, on top of your standard travel insurance.',
    dynamic: 'Please note – The enhanced trip disruption does not cover unused accommodation for delays of less than 24 hours.',
    info: '**Standard cover:**\\n\\nWhen your delay reaches 12 hours, you’ll get £25 for each full 12-hour delay period. You’re covered for delays caused by:\\n\\n<ul><li>Mechanical breakdowns</li><li>Industrial action or strikes</li><li>Severe weather</li></ul>\\n\\nIf your trip is cancelled or delayed by 12 hours or more, and there’s no alternative transport available, you are covered for abandoning your trip.\\n\\nYour policy won’t cover:<ul><li>Missed connections or missed international departures that don\'t leave from, or arrive in, the UK.</li><li>Delays to connecting flights or transport that doesn’t leave from, or arrive in, the UK</li></ul>',
  },
  hazardous_activities: {
    alt: `
            <p>
              Please let us know if you intend to participate in any risky or adventurous activities, so we can
              ensure you have the appropriate cover.
            </p>
        `,
    dynamic: `<p>To add on any of the sports on our extreme sports list, contact us by phone and quote your reference from the bottom of page.
           <a class="pointer" href="https://www.admiral.com/contact-us/travel" target="_blank">Contact Us</a></p>`,
  },
};

/**
 * Returns the cover text for a given option key.
 * @param key - The cover option key (e.g., 'gadget_cover')
 * @param type - The type of text: 'alt' | 'dynamic' | 'info'
 * @returns string
 */
export function getCoverText(
  key: string,
  type: CoverTextType,
): string {
  const cover = coverTexts[key];
  if (!cover) {
    return '';
  }

  const text = cover[type];

  return text || '';
}
